
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"41","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"fill":"#F0A53D","d":"M20.025 16.478a4.072 4.072 0 100-8.144 4.072 4.072 0 000 8.144z"}}),_c('path',{attrs:{"fill":"#EAD4AA","d":"M11.613 16.478a2.642 2.642 0 100-5.284 2.642 2.642 0 000 5.284zm16.757 0a2.642 2.642 0 100-5.284 2.642 2.642 0 000 5.284zm.014 1.857a4.972 4.972 0 00-2.997 1.011 7.54 7.54 0 012.29 5.407v3.549h3.855c.993 0 1.801-.796 1.801-1.775v-3.3c.017-2.703-2.205-4.892-4.95-4.892zm-16.195 6.783c0-2.272.942-4.312 2.424-5.772-.825-.613-1.852-1.011-2.98-1.011-2.744 0-4.966 2.189-4.966 4.892v3.333c0 .979.808 1.775 1.801 1.775h3.704v-3.217h.017z"}})]),_c('path',{attrs:{"fill":"#F0A53D","d":"M26.667 29.585c0 1.149-.841 2.083-1.875 2.083h-9.584c-1.034 0-1.874-.934-1.874-2.083V26.16c0-4.01 2.698-7.611 6.307-7.806.123 0 .36-.02.35-.02 3.68 0 6.658 3.31 6.658 7.397l.018 3.437v.417z"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h26.667v21.165H0z","transform":"translate(6.667 8.335)"}})])])])
          )
        }
      }
    